import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { CREATE_TICKET } from '../operations/mutations/create-ticket.js';
import { useSubmit } from './use-submit.js';

const useCreateTicket = ()=>{
    const [submitData, { onSubmit , reset  }] = useSubmit();
    const [createTicket, result] = useMutation(CREATE_TICKET);
    const [isSuccessful, setIsSuccessful] = React.useState(false);
    const [isSubmittable, setIsSubmittable] = React.useState(true);
    React.useEffect(()=>{
        if (result.called) {
            setIsSubmittable(false);
        }
        if (result.called && result.error) {
            setIsSubmittable(true);
        }
    }, [
        result
    ]);
    React.useEffect(()=>{
        if (submitData && isSubmittable && submitData.recaptchaToken) {
            createTicket({
                variables: swcHelpers.objectSpread({}, submitData)
            });
            reset();
        }
    }, [
        submitData,
        isSubmittable
    ]);
    React.useEffect(()=>{
        var ref, ref1;
        if ((ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createTicket) === null || ref1 === void 0 ? void 0 : ref1.success) {
            setIsSuccessful(true);
        }
    }, [
        result.data
    ]);
    return [
        onSubmit,
        {
            isLoading: result.loading,
            isCalled: result.called,
            isSuccessful,
            error: result.error
        }, 
    ];
};

export { useCreateTicket };
//# sourceMappingURL=use-create-ticket.js.map
